import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  addPodcast,
  editPodcast,
  episodeStatusChanged,
  getEpiosde,
  getPodcast,
} from "../../../features/slices/poadcast";
import {
  getCategoryDropDown,
  getTopicDropDown,
  imageUpload,
} from "../../../features/slices/liveStream";
import { toastService } from "../../../utils/toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import "ckeditor5/ckeditor5.css";
import {
  ListProperties,
  Alignment,
  List,
  Image,
  AutoImage,
  ImageInsert,
  ImageResize, // Add this
  ImageToolbar, // Add this
  ImageStyle, // Add this
  ImageCaption,
  SimpleUploadAdapter,
  Base64UploadAdapter,
} from "ckeditor5";

import {
  ClassicEditor,
  Bold,
  Essentials,
  Italic,
  Mention,
  Paragraph,
  Undo,
} from "ckeditor5";
import LoaderForImage from "../../LoaderForImage";
import DeleteModal from "../../DeleteModal";
import QuillEditor from "../../QuillEditor";
const initialState = {
  podcastName: "",
  categoryId: "",
  topicId: "",
  podcastLanguage: ["English"],
  podcastHostname: "",
  description: "",
  thumbnail: "",
  loading: false,
  id: "",
};
const EditDetailEpisode = () => {
  const [iState, setUpdateState] = useState(initialState);
  const [showEpisodeData, setShowEpisodeData] = useState({
    showEpisodeBtn: false,
    podcastId: "",
    showDeleteModal: false,
    episodeId: "",
  });
  const [errors, setErrors] = useState({});
  const [imageLoader, setImageLoader] = useState(false);
  const {
    categoryId,
    podcastLanguage,
    loading,
    podcastName,
    topicId,
    podcastHostname,
    thumbnail,
    description,
    id,
  } = iState;
  const { showEpisodeBtn, podcastId, showDeleteModal, episodeId } =
    showEpisodeData;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { episode } = useSelector((state) => state?.podcast);
  useEffect(() => {
    dispatch(getCategoryDropDown()).then((data) => {});
    dispatch(getTopicDropDown({ categoryId: state?.categoryData?.[0]?._id }));
  }, []);
  console.log({ state });

  useEffect(() => {
    if (state?.podcastId) {
      dispatch(getEpiosde({ podcastId: state?.podcastId }));
    } else {
      dispatch(getEpiosde({ podcastId: state?._id }));
      setUpdateState((prev) => ({
        ...prev,
        podcastId: state?._id,
        podcastName: state?.podcastName,
        categoryId: state?.categoryData?.[0]?._id,
        topicId: state?.topicData?.[0]?._id,
        podcastHostname: state?.podcastHostname,
        description: state?.description,
        thumbnail: state?.thumbnail,
        id: state?._id,
      }));
    }
  }, [state]);
  const { categoryDropDownData, topicDropDowndata } = useSelector(
    (state) => state.liveStream
  );
  const handleChangeCategory = (e) => {
    setErrors((prev) => ({ ...prev, [e.target.name]: "" }));
    setUpdateState({ ...iState, [e.target.name]: e.target.value });
    dispatch(getTopicDropDown({ categoryId: e.target.value })).then(
      (data) => {}
    );
  };
  const handleChange = (e) => {
    const { name, value } = e?.target;
    console.log(name);

    setErrors((prev) => ({ ...prev, [name]: "" }));
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
const handleQuillChange = (name, value) => {
  setErrors((prev) => ({ ...prev, [name]: "" })); // Reset error for the specific field
  setUpdateState((prev) => ({ ...prev, [name]: value })); // Dynamically update the corresponding state field
};
  const handleChangeEditor = (name, value) => {
    setErrors((prev) => ({ ...prev, [name]: "" }));
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleImage = (e) => {
    setErrors((prev) => ({ ...prev, ["thumbnail"]: "" }));
    const file = e.target.files[0];
    setImageLoader(true);
    if (file) {
      const formData = new FormData();
      formData.append("fileName", file);
      dispatch(imageUpload(formData)).then((res) => {
        if (res?.payload?.code === 200) {
          toastService.success("Image uploaded successfully");
          setImageLoader(false);
          setUpdateState((prev) => ({
            ...prev,
            thumbnail: res?.payload?.url,
          }));
        } else {
          toastService.error("Failed to upload");
          setImageLoader(false);
        }
      });
    } else {
      toastService.error("Please select an image");
    }
  };

  const validForm = () => {
    let formErrors = {};
    let isValid = true;
    if (!podcastName?.trim()) {
      formErrors.podcastName = "Podcast Name is required";
      isValid = false;
    }
    if (!categoryId?.trim()) {
      formErrors.categoryId = "Category is required";
      isValid = false;
    }
    if (!topicId?.trim()) {
      formErrors.topicId = "Topic is required";
      isValid = false;
    }
    if (!description?.trim()) {
      formErrors.description = "Description is required";
      isValid = false;
    }
    if (!podcastHostname?.trim()) {
      formErrors.podcastHostname = "Podcast Hostname is required";
      isValid = false;
    }
    if (!thumbnail?.trim()) {
      formErrors.thumbnail = "Thumbnail is required";
      isValid = false;
    }
    setErrors(formErrors);
    return isValid;
  };
  const handleSubmit = () => {
    if (validForm()) {
      const data = {
        podcastName,
        categoryId,
        topicId,
        podcastLanguage,
        podcastHostname,
        description,
        thumbnail,
        id,
      };
      dispatch(editPodcast(data)).then((res) => {
        if (res?.payload?.code === 200) {
          toastService.success("Podcast added successfully");
          navigate("/podcast");
          setShowEpisodeData((prev) => ({
            ...prev,
            showEpisodeBtn: true,
            podcastId: res?.payload?.addBanner?._id,
          }));
        } else {
          toastService.error(res?.payload?.message);
          console.log({ res });
        }
      });
    }
  };
  console.log({ podcastId });
  const handleStatus = (e, id) => {
    const value = e.target.checked ? "ACTIVE" : "INACTIVE";
    const data = { id: id, status: value };
    dispatch(episodeStatusChanged(data)).then((data) => {
      if (data?.payload?.code === 200) {
        dispatch(getEpiosde({ podcastId })).then((data) => {
          if (data?.payload?.code === 200) {
            toastService.success("Status updated successfully");
            // setUpdateState((prev) => ({
            //   ...prev,
            //   status: "",
            // }));
          } else {
            toastService.error(data?.payload?.message);
          }
        });
      }
    });
  };
  const hanldeClose = () => {
    setShowEpisodeData((prev) => ({
      ...prev,
      showDeleteModal: false,
    }));
  };
  const handleShowDeleteModal = (id) => {
    console.log({ id });

    setShowEpisodeData((prev) => ({
      ...prev,
      showDeleteModal: true,
      episodeId: id,
    }));
  };
  const handleDelete = () => {
    dispatch(episodeStatusChanged({ id: episodeId, status: "DELETED" })).then(
      (res) => {
        if (res?.payload?.code == 200) {
          dispatch(getEpiosde({ podcastId: state?.podcastId }));
          hanldeClose();
          toastService.success("Episode deleted successfully");
        } else {
          toastService.error(res?.payload?.message);
          console.log(res);
        }
      }
    );
  };
  return (
    <>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="TitleBox Border">
              <h4 className="Title">Edit Podcast</h4>
            </div>
            <div className="CommonForm">
              <div className="form-group">
                <label>Podcast Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter podcast name"
                  name="podcastName"
                  value={podcastName}
                  onChange={handleChange}
                />
                {errors.podcastName && (
                  <p className="d-flex justify-content-start text-danger mt-2 ">
                    {errors.podcastName}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label>Category</label>
                <select
                  className="form-control"
                  name="categoryId"
                  value={categoryId}
                  onChange={handleChangeCategory}
                >
                  <option>select</option>
                  {categoryDropDownData?.result?.map((res) => {
                    return (
                      <option value={res?._id}>{res?.categoryName}</option>
                    );
                  })}
                </select>
                {errors.categoryId && (
                  <p className="d-flex justify-content-start text-danger mt-2 ">
                    {errors.categoryId}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label>Topic</label>
                <select
                  className="form-control"
                  name="topicId"
                  value={topicId}
                  onChange={handleChange}
                >
                  <option>select</option>
                  {topicDropDowndata &&
                    topicDropDowndata?.result?.map((res) => {
                      return <option value={res?._id}>{res?.topicName}</option>;
                    })}
                </select>
                {errors.topicId && (
                  <p className="d-flex justify-content-start text-danger mt-2 ">
                    {errors.topicId}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label>Podcast Host Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter podcast name"
                  name="podcastHostname"
                  value={podcastHostname}
                  onChange={handleChange}
                />
                {errors.podcastHostname && (
                  <p className="d-flex justify-content-start text-danger mt-2 ">
                    {errors.podcastHostname}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label>Podcast Description</label>
                {/* <CKEditor
                  editor={ClassicEditor}
                  config={{
                    toolbar: [
                      "undo",
                      "redo",
                      "|",
                      "bold",
                      "italic",
                      "|",
                      "paragraph",
                      "heading1",
                      "heading2",
                      "|",
                      "bulletedList",
                      // "numberedList",
                      "alignment",
                      // "toggleImageCaption",
                      // "imageTextAlternative",
                      // "ckboxImageEdit",
                      // "insertImage",
                      // "imageResize",
                    ],
                    list: {
                      properties: {
                        styles: true,
                        startIndex: true,
                        reversed: true,
                      },
                    },
                    plugins: [
                      List,
                      ListProperties,
                      Bold,
                      Essentials,
                      Italic,
                      Mention,
                      Paragraph,
                      Undo,
                      Alignment,
                      // Image,
                      // AutoImage,
                      // ImageInsert,
                      // ImageResize, // Add this
                      // ImageToolbar, // Add this
                      // ImageStyle, // Add this
                      // ImageCaption,
                      // SimpleUploadAdapter,
                      // Base64UploadAdapter, // Add this
                    ],
                    // image: {
                    //   toolbar: [
                    //     "imageTextAlternative",
                    //     "toggleImageCaption",
                    //     "imageStyle:inline",
                    //     "imageStyle:block",
                    //     "imageStyle:side",
                    //   ],
                    // },
                    // simpleUpload: {
                    //   uploadUrl: "your-server-url-to-handle-image-upload", // Add your upload API here
                    // },
                    mention: {
                      // Mention configuration
                    },
                  }}
                  name="description"
                  data={description || ""}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    // console.log({ event, editor, data })
                    handleChangeEditor("description", data);
                  }}
                />
                {errors.description && (
                  <p className="d-flex justify-content-start text-danger mt-2 ">
                    {errors.description}
                  </p>
                )} */}
                <QuillEditor
                  name="description"
                  value={description}
                  onChange={handleQuillChange}
                  error={errors.description}
                  // Optional custom height
                />
              </div>
            </div>
            <div className="TitleBox Border">
              <h4 className="Title">Podcast Audio &amp; Video</h4>
            </div>
            {imageLoader ? (
              <LoaderForImage />
            ) : (
              <div className="CommonForm">
                <div className="UploadBox Image">
                  <span
                    style={{
                      zIndex: "99",
                    }}
                  >
                    {!thumbnail ? (
                      <img
                        src={require("../../../assets/images/upload-video.png")}
                      />
                    ) : (
                      <>
                        <img
                          src={thumbnail}
                          alt=""
                          style={{
                            position: "absolute",
                            top: "0",
                            left: "0",
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            mixBlendMode: "darken",
                          }}
                        />
                        <i
                          className="fas fa-edit"
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            color: "#fff",
                            background: "rgba(0, 0, 0, 0.6)",
                            borderRadius: "50%",
                            padding: "5px",
                            zIndex: 2, // Place icon above the video
                            cursor: "pointer",
                          }}
                        ></i>
                      </>
                    )}
                  </span>
                  <input
                    type="file"
                    accept=".png,.jpg,.jpeg"
                    name="thumbnail"
                    onChange={handleImage}
                  />
                  {!thumbnail && (
                    <p>
                      <label>Click to upload</label> or <br /> drag &amp; drop
                    </p>
                  )}
                </div>
                {errors.thumbnail && (
                  <p className="d-flex justify-content-start text-danger mt-2 ">
                    {errors.thumbnail}
                  </p>
                )}
                {/* <div className="UploadBox">
              <span>
                <img src="images/upload-video.png" />
              </span>
              <p>
                <label>Click to upload</label> or <br /> drag &amp; drop
              </p>
            </div> */}
              </div>
            )}
            <button className="Button" onClick={handleSubmit}>
              Edit PodCast
            </button>
            {/* <Link
              to={"/podcast/addEpisode"}
              className="Button"
              state={{ podcastId: id, redirect: "/podcast/editEpisode" }}
            >
              Add Episode
            </Link>

            <div className="TitleBox Border mt-4">
              <h4 className="Title">List of All Episodes</h4>
            </div> */}
            {/* <div className="TableList">
              {episode?.result?.[0]?.paginationData?.length > 0 ? (
                <table className="table-hover">
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Episode Id</th>
                      <th>Episode Name</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {episode?.result?.[0]?.paginationData.map((res, i) => {
                      return (
                        <tr key={res?._id}>
                          <td>{i + 1}</td>
                          <td>{res?.episod_number}</td>
                          <td>{res?.episodName}</td>
                          <td>
                            <span
                              className={`${
                                res?.status == "ACTIVE" ? "Green" : "Red"
                              }`}
                            >
                              {res?.status == "ACTIVE"
                                ? "Available"
                                : "Blocked"}
                            </span>
                          </td>
                          <td>
                            <div className="Actions">
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={res?.status == "ACTIVE"}
                                  name="status"
                                  onChange={(e) => handleStatus(e, res?._id)}
                                />
                                <span className="slider" />
                              </label>
                              <Link
                                to={"/podcast/episodeDetails"}
                                className="Eyes"
                                state={res}
                              >
                                <i className="fa-regular fa-eye" />
                              </Link>
                              <Link
                                to={"/podcast/editDetailEpisode"}
                                className="Edit"
                                state={{
                                  ...res,
                                  redirect: "/podcast/addPodCast",
                                }}
                              >
                                <i className="fa-regular fa-pen-to-square" />
                              </Link>
                              <a
                                className="Delete"
                                onClick={() => handleShowDeleteModal(res?._id)}
                              >
                                <i className="fa-regular fa-trash-can" />
                              </a>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                   
                  </tbody>
                </table>
              ) : (
                <p className="d-flex justify-content-center h-100 text-success">
                  There is no Episode ! please add the Episode
                </p>
              )}
            </div> */}
            {/* <div className="Pagination mb-4">
              <p>Showing 1 to 10 of 97 results : 50</p>
              <ul>
                <li>
                  <a href="javascript:void(0);">
                    <i className="fa fa-angle-left" />
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);">1</a>
                </li>
                <li className="active">
                  <a href="javascript:void(0);">2</a>
                </li>
                <li>
                  <a href="javascript:void(0);">3</a>
                </li>
                <li>
                  <a href="javascript:void(0);">4</a>
                </li>
                <li>
                  <a href="javascript:void(0);">...</a>
                </li>
                <li>
                  <a href="javascript:void(0);">20</a>
                </li>
                <li>
                  <a href="javascript:void(0);">21</a>
                </li>
                <li>
                  <a href="javascript:void(0);">
                    <i className="fa fa-angle-right" />
                  </a>
                </li>
              </ul>
            </div> */}
            {/* <button className="Button Discard">Discard</button>
            <button className="Button" onClick={handleSubmit}>
              Save
            </button> */}
          </div>
        </div>
      </div>
      {showDeleteModal && (
        <DeleteModal
          hanldeClose={hanldeClose}
          statement={"Episode "}
          handleDelete={handleDelete}
        />
      )}
    </>
  );
};

export default EditDetailEpisode;
